import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogapproveconfirmComponent } from '../dialogapproveconfirm/dialogapproveconfirm.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmdialogApproveService {

  constructor(private dialog:MatDialog) { }

  openDialog(){
   return this.dialog.open(DialogapproveconfirmComponent,{
     width:'40%',
   });
  }
}
